<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div class="add-to-portfolio">
        <Portal v-if="instruments" to="breadcrumb_addWatchlistsInstrumentsToPortfolio">
          Zu Portfolio hinzufügen
        </Portal>

        <fin-add-to-portfolio :instruments="instruments"
                              :title="title"
                              :to="to"
                              @addToPortfolioDone="$emit('addToPortfolioDone')"/>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinAddToPortfolio from '@/components/common/portfolio/AddToPortfolio/index'
import FinDataLoader from "@/components/common/DataLoader"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getEtfById, getShareById} from "@/components/pages/myWatchlist/WatchlistDetails/graphql"

export default {
  name: 'fin-watchlistsdetails-add-to-portfolio',
  components: {
    FinDataLoader,
    FinAddToPortfolio
  },
  props: {
    /* Set via router */
    id: {
      type: String
    },
    assetClassId: {
      type: String
    },
    instrumentId: {
      type: String
    }
  },
  data() {
    return {
      title: 'Wertpapier in Portfolio hinzufügen',
      instruments: [],
      to: {name: 'watchlistDetails', params: {id: this.id}}
    }
  },
  methods: {
    async loadData() {
      const assetClassId = this.assetClassId

      try {
        let result = await API.graphql(graphqlOperation(assetClassId === 'SHARE' ? getShareById : getEtfById, {
          instrumentId: this.instrumentId.toUpperCase()
        }))
        const resultData = assetClassId === 'SHARE' ? result.data.getShare : result.data.getEtf
        if (resultData === null) {
          throw new Error('No ' + assetClassId + ' found by given id ' + this.instrumentId)
        }
        this.instruments.push(resultData)
      } catch (error) {
        console.log("error loading " + assetClassId + " for adding to portfolio from watchlist", error, this.id, this.instrumentId)
        await this.$router.push(this.to)
        this.$toasted.global.finToast({
          message: `Es konnten nicht alle benötigten Daten geladen werden. Bitte versuche es erneut.`,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-portfolio {
  background-color: #fff;
}
</style>
